import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openCustomDialog } from '../../../redux/slices/customDialogSlice';
import EventSessionCreate from '../../../app/event/EventSessionCreate';

const CreateEventSessionAction = ({ payload: { instant = false, guest }, onComplete }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const onClose = onComplete ? () => onComplete(null) : undefined;
        dispatch(openCustomDialog(<EventSessionCreate instant={instant} guest={guest} onSubmit={onComplete} onCancel={onClose}/>, {
            beforeClose: onClose,
        }));
        // eslint-disable-next-line
    }, []);
};

export default CreateEventSessionAction;
